import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormComponent } from './form.component';
import {FormListGeneratorModule} from "../form-list-generator/form-list-generator.module";



@NgModule({
  declarations: [FormComponent],
  exports: [
    FormComponent
  ],
  imports: [
    CommonModule,
    FormListGeneratorModule
  ]
})
export class FormModule { }
